import React from 'react'
import qticketmobileapp from '../../../../assets/img/qticket_mobileapp.webp'
import karakstopmobileapp from '../../../../assets/img/karakstop_mobileapp.webp'
import justdubaiwordpress from '../../../../assets/img/justdubai_wordpress.webp'
import google from '../../../../assets/img/goole_play.webp'
import app from '../../../../assets/img/app_store.webp'
import aljazi from '../../../../assets/img/aljazi.webp'
import digitalsauce from '../../../../assets/img/digital_sauce.webp'
import learning from '../../../../assets/img/360_learning.webp'
import qatarday from '../../../../assets/img/qatarday1.webp'
import amal from '../../../../assets/img/aamalmed.webp'
import coastalholding from '../../../../assets/img/coastalholding.webp'

import qticketlogo from '../../../../assets/img/qtickets.webp'
import sportsmonkslogo from '../../../../assets/img/sportsmonks.webp'
import citycenterlogo from '../../../../assets/img/citycenter_colored.svg'
import qatardaylogo from '../../../../assets/img/qatarday_colored.webp'
import karakstoplogo from '../../../../assets/img/karak_stop.webp'
import justdubailogo from '../../../../assets/img/just_dubai.webp'
import aljazilogo from '../../../../assets/img/aljazi_logo.webp'
import digitalsaucelogo from '../../../../assets/img/digitalsauce_logo.svg'
import learninglogo from '../../../../assets/img/learning_logo.webp'
import amallogo from '../../../../assets/img/amal_logo.webp'
import coastalqatarlogo from '../../../../assets/img/coastalqatar_logo.webp'


import { FaChevronRight } from 'react-icons/fa6'
import './Projects.css'
import { Link } from 'react-router-dom'

function Projects() {

    const PtojectList = [
        {
            logo:aljazilogo,
            tittle:"Wordpress Website",
            desc: "360 Gigabytes designed and developed a dynamic WordPress website for Al Jazi Real Estate, built to showcase their premium properties with clarity and style. The platform highlights listings, amenities, and updates while ensuring a seamless user experience across all devices.",
            platforms: "Website",
            technology: "WordPress",
            waimg: [],
            img: aljazi,
            path: "https://www.aljazi.com.qa/"
        },
        {
            logo:digitalsaucelogo,
            tittle:"Design and Development",
            desc: "For 360 Digital Sauce, we delivered a complete design and development solution that reflects their bold, creative identity. The result is a visually striking and high-performing platform that enhances brand storytelling and engagement.",
            platforms: "Website",
            technology: "Laravel",
            waimg: [],
            img: digitalsauce,
            path: "https://360-digitalsauce.com/"
        },
        {
            logo:qticketlogo,
            tittle:"Website & Mobile App Development",
            desc: "360 Gigabytes spearheaded the design, development, and optimization of Q-Tickets’ website and mobile app, powering one of the region’s most trusted online ticketing platforms. The solution combines performance, security, and scalability to handle high traffic and smooth transactions.",
            platforms: "iOS, Android. website",
            technology: ".net core",
            waimg: [google, app],
            img: qticketmobileapp,
            path: "https://q-tickets.com/"
        },
        {
            logo:learninglogo,
            tittle:"Wordpress Website",
            desc: "We developed the LearnIt website on WordPress, creating an intuitive learning hub for online courses and knowledge sharing. The design focuses on clarity, accessibility, and easy navigation for both learners and educators.",
            platforms: "Website",
            technology: "WordPress",
            waimg: [],
            img: learning,
            path: "https://learning.360-bytes.com/"
        },
        {
            logo:qatardaylogo,
            tittle:"Design and Development",
            desc: "For Qatar Day, 360 Gigabytes handled the full design and development of a modern, media-rich platform. The website delivers a clean, user-centric layout that supports diverse content ranging from news and events to videos and infographic community updates.",
            platforms: "Website",
            technology: ".net",
            waimg: [],
            img: qatarday,
            path: "https://www.qatarday.com/"
        },
        {
            logo:amallogo,
            tittle:"Wordpress Website",
            desc: "We built Aamal Med’s WordPress website with an integrated blog section to support their healthcare communications and outreach. The platform balances professional design with user-friendly navigation to enhance audience engagement.",
            platforms: "Website",
            technology: "WordPress",
            waimg: [],
            img: amal,
            path: "https://aamalmed.com/"
        },
        {
            logo:coastalqatarlogo,
            tittle:"Wordpress Website",
            desc: "360 Gigabytes developed a responsive WordPress website for Coastal Chalengineers that showcases their engineering expertise and project portfolio. The site emphasizes precision, reliability, and ease of access for potential clients and partners.",
            platforms: "Website",
            technology: "WordPress",
            waimg: [],
            img: coastalholding,
            path: "https://coastalholding.com/"
        },
    ]

  return (
    <section className='pro-sec'>
        <div className='container'>
          <h3>Featured Projects</h3>
        </div>
        <div className='container'>
            {
                PtojectList.map((item,index)=>(
                    <div className='hmproject-area' key={index}>
                    <div className='hmproject-img'><img src={item.img} alt={item.tittle} width={1200} height={800} loading="lazy"/></div>     
                    <div className='hmproject-txt'>
                        <img src={item.logo} alt={item.tittle} loading="lazy" width={200} height={60}/> 
                        <h4>{item.tittle}</h4>
                        <p>{item.desc}</p>
                        <div className='platech'>
                            <div className='platech-sec'>
                                <h5>Platforms</h5> 
                                <h6>{item.platforms}</h6>  
                            </div>
                            <div className='platech-sec'>
                                <h5>Technology</h5> 
                                <h6>{item.technology}</h6>  
                            </div>
                        </div>
                        <div className='plapla'>
                        {item.waimg.map((image, imgIndex) => (
                            <img key={imgIndex} src={image} alt={`App store ${imgIndex}`} width={130} height={40} loading="lazy" />
                            ))}
                            
                        </div>
                        <Link to={item.path} className='btn-main' target='_blank'><span>View</span> <FaChevronRight/></Link>
                    </div> 
                    </div>
                ))
            }
            
        </div>
    </section>
  )
}

export default Projects
